<template>
  <div>
    <containerOrderModal v-if="showNewContainerDialog" @close="showNewContainerDialog = false"/>
    <disposalOrder v-if="disposalOrderModal" :container="currentContainer" :task="currentOperation" @close="disposalOrderModal = false"/>

    <DataTable 
      class="containerTable"
      :loading="loading" 
      :value="containers"
      :filters="filters" >
      <template #header v-if="!disabled">
        <div class="p-d-flex p-jc-between ">
          <div class="p-field-checkbox p-mb-0">
            <label for="inactive" class="p-mr-2 p-mt-1">Se tidligere containere</label>
            <InputSwitch id="inactive" name="inactive" v-model="filters['active']"/>
          </div>
          <Button label="Container" @click="showNewContainerDialog = true" icon="pi pi-plus" class="p-mr-2"/>
        </div>
        </template>
      <Column header="Størrelse">
        <template #body="slotProps">
          <div class="p-d-flex">
          <img height="64" :src="slotProps.data.container.imageurl"/>
          <p class="p-my-auto p-ml-1">{{ slotProps.data.container.size }} {{ slotProps.data.container.measurementunit }}</p> 
          </div>
        </template>
      </Column>
      <Column field="wastetype">
        <template #header>
          <p v-tooltip.top="'Avfallstype ved sist henting'">Avfall</p>
        </template>
        <template #body="slotProps">
          <p>{{ slotProps.data.wastetype }}</p>
        </template>
      </Column>
      <Column field="dateupdated">
        <template #header>
          <p class="p-text-center" v-tooltip.top="'Dato for siste Tømme/Bytte eller Innhent/Avslutte ordre'">Siste aktivitet</p>
        </template>
        <template #body="slotProps">
          <p v-if="slotProps.data.updateddate" class="p-text-center">{{ $moment.unix(slotProps.data.updateddate.seconds).format('ll') }}</p>
          <p v-else></p>
        </template>
      </Column>
      
      <Column v-if="!disabled">
        <template #body="slotProps" >
          <div v-if="slotProps.data.active" class="p-d-flex p-jc-end">
            <Button 
              label="Tømme/Bytte" 
              class="p-button-secondary p-mr-2" 
              @click="setInactive(slotProps.data, 'Tømme/Bytte')" 
            ></Button>
            <Button 
              label="Innhent/Avslutte" 
              class="p-button-secondary p-mr-2" 
              @click="setInactive(slotProps.data, 'Innhent/Avslutte')" 
            ></Button>
          </div>
        </template>
      </Column>
      <Column field="active" header="Aktiv" filterMatchMode="notEquals"></Column>
    </DataTable> 
  </div>
</template>

<script>
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputSwitch from 'primevue/inputswitch';
import containerOrderModal from '@/components/containers/containerOrderModal'
import disposalOrder from '@/components/disposalOrders/disposalOrder'


export default {
name: 'containerList',

components: {
  DataTable,
  Column,
  InputSwitch,
  containerOrderModal,
  disposalOrder
},

props: {
  disabled: {
    type: Boolean, 
    default: false,
  }
},


data(){
  return{
    inactive: false,
    loading: false,
    filters: {
      active: false
    },
    showNewContainerDialog: false,
    currentContainer: null,
    currentOperation: null,
    disposalOrderModal: false
  }
},




mounted(){
  this.loading = true
    this.$store.dispatch("containerOrders/inspect", this.$route.params.id).then(() => {
      if(this.disabled)
        this.filters.active = true
      this.loading = false
    })
},

methods:{
  closeModal(){
    this.displayModal = false
    this.currentContainer = null
  },
  
  setInactive(container, task){
    this.currentContainer = container 
    this.currentOperation = task
    this.disposalOrderModal = true 
    //this.$store.dispatch('containerOrders/update', container)
  }
},

computed: {
  containers(){
    return this.$store.getters["containerOrders/list"]
  },
},

}
</script>

<style lang="sass">

.containerTable
  th:last-child, td:last-child
    display: none
  
</style>
